import { UNIT_POUNDS, UNIT_STONE, default as convert } from "./weightUnits";

const MIN_STONE = 6;
const MAX_STONE = 70;
const MAX_POUND = 13.9;

export const STONE_POUNDS_LIMITS = {
  min: {
    stone: MIN_STONE,
    pounds: 0,
    total: MIN_STONE
  },
  max: {
    stone: MAX_STONE,
    pounds: MAX_POUND,
    total: MAX_STONE + convert(MAX_POUND, UNIT_POUNDS, UNIT_STONE)
  }
};

export const KG_LIMITS = {
  min: 0.1,
  max: 450
};

export const POUND_LIMITS = {
  min: 0.1,
  max: 999
};

export const SEQUENCE_POUND_LIMITS = {
  min: 51,
  max: 999
};

export const isKgUnit = unit => /^kg/i.test(unit);

export const isStoneUnit = unit => /^st/i.test(unit);

export const isPoundUnit = unit => !isStoneUnit(unit) && !isKgUnit(unit);
